import Vue from 'vue'
import langs from '@/i18n/'

const state = {
  langs,
  active: 'en',
  isDefault: true
}

const getters = {
  langs (state) {
    return state.langs
  },
  activeLang (state) {
    return state.langs.find(l => l.code === state.active)
  },
  i18n: (state, getters) => (group, name) => {
    if (!getters.activeLang) return ''
    return (getters.activeLang.translations[group] || {})[name] || name
  },
  isDefault (state) {
    return state.isDefault
  }
}

const mutations = {
  setActiveLang (state, code) {
    Vue.set(state, 'active', code)
    Vue.set(state, 'isDefault', false)
  }
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: false
}
